import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  spaceId: string | number;
  createReferences?: boolean;
  name?: string;
};
const [useDuplicateKit, duplicateKit] = createAsyncAction(
  "kits/duplicate",
  async ({ kitId, spaceId, createReferences, name }: Args) => {
    const res = await API.call<{ kitVersion: string }>({
      endpoint: `/kits/${spaceId}/${kitId}/duplicate`,
      method: "POST",
      data: { create_references: createReferences, name },
    });
    return { ...res, result: res.result.kitVersion };
  }
);
export default useDuplicateKit;
export { duplicateKit };
